/**
 * TableHeader - Header rows for registration tables
 * @module wellRegistrationTotals/components/organisms/RegistrationTable/TableHeader
 */

import React from "react";
import { TableHead, TableRow, TableCell } from "@material-ui/core";

/**
 * Two-row header with grouped column headers
 * @param {Object} props
 * @param {string} [props.firstColumnLabel="Year"] - Label for first column
 */
const TableHeader = React.memo(({ firstColumnLabel = "Year" }) => (
  <TableHead>
    <TableRow>
      <TableCell rowSpan={2}>{firstColumnLabel}</TableCell>
      <TableCell colSpan={2} className="group-header">
        Exempt Wells
      </TableCell>
      <TableCell colSpan={4} className="group-header">
        Non-Exempt Wells
      </TableCell>
      <TableCell colSpan={2} className="group-header">
        Monitor Wells
      </TableCell>
      <TableCell rowSpan={2}>Total</TableCell>
    </TableRow>
    <TableRow>
      <TableCell>Grandfathered</TableCell>
      <TableCell>New</TableCell>
      <TableCell>Grandfathered</TableCell>
      <TableCell>Class 1</TableCell>
      <TableCell>Class 2</TableCell>
      <TableCell>Class 3</TableCell>
      <TableCell>Water</TableCell>
      <TableCell>Envr</TableCell>
    </TableRow>
  </TableHead>
));

TableHeader.displayName = "TableHeader";

export default TableHeader;
